import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChessBoard, faChessKnight, faChessRook } from "@fortawesome/free-solid-svg-icons";
import { type Choice } from "../types/types";

// Define an interface for each choice
// Choices array using the defined interface
export const choices: Choice[] = [
  {
    id: 1,
    name: "Claimant",
    icon: <FontAwesomeIcon className="h-5 w-5 bg-red-100 p-2 text-black" icon={faChessRook} />,
    value: "Claimant",
  },
  {
    id: 2,
    name: "Defendant",
    icon: <FontAwesomeIcon className="h-5 w-5 bg-blue-200 p-2 text-black" icon={faChessKnight} />,
    value: "Defendant",
  },
  {
    id: 3,
    name: "All Parties",
    icon: <FontAwesomeIcon className="h-5 w-5 bg-green-100 p-2 text-green-800" icon={faChessBoard} />,
    value: "All Parties",
  },
];
